import "./AdminMenu.css";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { MainContainer, MainContent } from "../common/components/Layout";
import { User, isAdmin } from "../auth/api/UserModel";
import { adminCheckMe } from "../auth/api/UserApi";
import { handleErrorCommon } from "../common/api/Api";
import { useErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { LoginUserComponent } from "./LoginUserComponent";

/**
 * メニュー画面のコンポーネントです。
 *
 * @returns メニュー画面のコンポーネント
 */
export const AdminMenuPage = (): JSX.Element => {
  const [loginUser, setLoginUser] = useState<User>();
  const { showBoundary } = useErrorBoundary();
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const result = await adminCheckMe();
      if (result.error) {
        return handleErrorCommon(result.error?.response?.data, result.error, showBoundary, t);
      }
      setLoginUser(result.data);
    })();
  }, []);

  if (!loginUser) {
    return <></>;
  }

  return (
    <MainContainer>
      <MainContent>
        <LoginUserComponent />
        <div className="h-full w-full flex items-center justify-center">
          <div className="flex flex-col justify-center w-96">
            <MenuPageButtons user={loginUser} />
          </div>
        </div>
      </MainContent>
    </MainContainer>
  );
};

interface MenuPageButtonsProps {
  user: User;
}

export const MenuPageButtons = (props: MenuPageButtonsProps): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (isAdmin(props?.user)) {
    return (
      <>
        <div className="rcui-menu-box rcui-menu-button-blue" onClick={() => navigate("/admin/list")}>
          {t("menu.customerInfoMenu")}
        </div>
        <div className="rcui-menu-box rcui-menu-button-blue" onClick={() => navigate("/admin/tenantList")}>
          {t("menu.customerTenantMenu")}
        </div>
        <div className="rcui-menu-box rcui-menu-button-red" onClick={() => navigate("/admin/login")}>
          {t("menu.backLogin")}
        </div>
      </>
    );
  } else {
    return <></>;
  }
};
